import { IAppConfig } from '../types';
import defaultConfig from '../../config/config.default.json';

export async function getConfig(): Promise<IAppConfig> {
  return (await getEnvConfig().then(envConfig => ({
    ...defaultConfig,
    ...envConfig,
  }))) as IAppConfig;
}

export async function getEnvConfig(): Promise<IAppConfig> {
  const configUrl =
    // eslint-disable-next-line no-restricted-globals
    location.href.slice(0, location.href.lastIndexOf('/')) + '/config.json';
  console.log('config url:', configUrl);
  return await fetch(configUrl)
    .then(response => response.json())
    .catch(reason => {
      console.error(reason);
    });
}
